import * as React from "react";
import { Props } from "../../types/global";
import { AuthService } from "./auth-service";
import PubSub from 'pubsub-js';
import { dialogService } from "react-api-dialog";
import { Social } from "./Social";
import { messageDialog } from "../dialogs/MessageDialog";
import { AuthHeader } from "./AuthHeader";
import { Form, FormRef } from "@ajayvikas/react-fluent-validation";
import { Input } from "../Controls/Input";
import { guestCheckoutValidator, loginValidator } from "./validators";
import t from "../i18n";
import { RegisterWithAnalytics, VerifyWithAnalytics, ForgotPasswordWithAnalytics } from ".";
import { } from "../common/OneSignal";
import { btnStyles } from "../_styles/button";
import { css } from "emotion";
import classNames from "classnames";
import { setGuestEmail } from "../services/helper-service";
import { CatalogService } from "../services/catalog-service";

declare type LoginState = {
    email: string,
    password: string,
    rememberMe: boolean,
    guestEmail: string,
}
export default class Login extends React.Component<Props<{ showGuestCheckout: boolean | false }>, LoginState> {
    readonly state: LoginState = { rememberMe: true } as LoginState;
    form: FormRef | null;
    guestForm: FormRef | null;
    assignFormRef = (form: FormRef | null) => {
        this.form = form;
    }
    assignGuestFormRef = (form: FormRef | null) => {
        this.guestForm = form;
    }
    showMessage = (message: string, title: string) => {
        if (this.props.ok) {
            alert(message);
        } else {
            messageDialog(message, title);
        }
    }
    showRegister = () => {
        if (this.props.ok) {
            dialogService.replaceComponent(RegisterWithAnalytics, "/register");
        } else {
            this.props.history.push("/register");
        }
    }
    showVerify = () => {
        if (this.props.ok) {
            dialogService.replaceComponent(VerifyWithAnalytics, "/verify");
        } else {
            this.props.history.push("/verify");
        }
    }
    showForgotPassword = () => {
        if (this.props.ok) {
            dialogService.replaceComponent(ForgotPasswordWithAnalytics, "/forgot-password");
        } else {
            this.props.history.push("/forgot-password");
        }
    }
    onGuestCheckout = async () => {
        if (!this.guestForm) return;
        const validationResult = this.guestForm.submit();
        const isValid = validationResult?.isValid() ?? false;
        if (isValid === false) {
            this.showMessage(t.error("validation_error"), t.menu("login"));
            return;
        }
        setGuestEmail(this.state.guestEmail);
        this.onGuestSuccess();
        return { type: "guest-checkout" };
    }
    onLogin = async () => {
        if (!this.form) return;
        const validationResult = this.form.submit();
        const isValid = validationResult?.isValid() ?? false;
        if (isValid === false) {
            this.showMessage(t.error("validation_error"), t.menu("login"));
            return;
        }
        dialogService.showPreloader();
        const response = await AuthService.login(this.state.email, this.state.password, this.state.rememberMe);
        await dialogService.hidePreloader();
        if (response.succeeded === true) {
            if (response.isAdmin) {
                window.location.href = response.url;
            } else {
                this.onLoginSuccess();
            }
        } else {
            switch (response.statusCode) {
                case "registration-confirmation":
                    localStorage.setItem("un", this.state.email);
                    this.showVerify();
                    break;
                case "locked-out":
                    this.showMessage(t.error("user_locked"), t.menu("login"));
                    break;
                case "invalid":
                    this.showMessage(t.validations("invalid_id_pass"), t.menu("login"));
                    break;
            }
        }
    }
    onLoginSuccess = () => {
        PubSub.publish("AUTH", "LOGIN");
        let OneSignal = window.OneSignal || [];
        let email = this.state.email;
        OneSignal.push(function () {
            OneSignal.sendTag("user_id", email);
        });
        if (this.props.ok) this.props.ok(true);
        else this.props.history.replace("/topup");
    }
    onGuestSuccess = () => {
        PubSub.publish("AUTH", "LOGIN");
        let OneSignal = window.OneSignal || [];
        let email = this.state.email;
        OneSignal.push(function () {
            OneSignal.sendTag("user_id", email);
        });
        if (this.props.ok) this.props.ok(true);
        else this.props.history.replace("/topup");
    }
    onCancel = () => {
        if (this.props.cancel) this.props.cancel();
        else (this.props.history.goBack())
    }
    render() {
        const showGuest = this.props.match.params && this.props.match.params.showGuestCheckout;
        const showLogin = (CatalogService.isSiteRedemptionPIN() === false || CatalogService.isSiteVodafoneFiji());
        return (
            <div className="auth container small-gutter">
                <div className="auth-box">
                   {showLogin && <Form ref={this.assignFormRef} object={this.state} validator={loginValidator}>
                        <AuthHeader text={t.menu("login")} showLogo={!!this.props.ok} />
                        <Social onLoginSuccess={this.onLoginSuccess} />
                        <div className="form-group relative">
                            <h5>{t.topup("user_name_label")}</h5>
                            <Input type="text" className="form-control" propertyName="email"
                                value={this.state.email || ""}
                                onChange={e => this.setState({ email: e.target.value })} maxLength={100} />
                        </div>
                        <div className="form-group relative">
                            <h5>{t.topup("password_label")}</h5>
                            <Input type="password" className="form-control" propertyName="password"
                                value={this.state.password || ""}
                                onChange={e => this.setState({ password: e.target.value })} maxLength={100} />
                        </div>
                        <div className="form-group">
                            <div className="row">
                                <div className="col-6">
                                    <div className="checkbox">
                                        <label>
                                            <input type="checkbox" checked={!!this.state.rememberMe} onChange={e => this.setState({ rememberMe: e.target.checked })} />
                                            <h5 style={{ display: "inline", marginLeft: 5 }}>{t.login("remember_me")}</h5>
                                        </label>
                                    </div>
                                </div>
                                <div className="col-6 text-right">
                                    <a href="javascript:void(0)" onClick={this.showForgotPassword}>
                                        <h5>{t.menu("forgot_password")}</h5>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="form-group text-right">
                            {/* <a className="button white text-center login-cancel-btn" onClick={this.onCancel}>{t.common("cancel_button")}</a> */}
                            <a className={classNames(['button', css(btnStyles.default), 'text-center'])} onClick={this.showRegister}>{t.menu("register")}</a>
                            <a className={classNames(['button', css(btnStyles.default), 'text-center'])} onClick={this.onLogin}>{t.menu("login")}</a>
                        </div>
                        {/* <div>
                            <a href="javascript:void(0)" onClick={this.showRegister}>{t.login("register_link")}</a>
                        </div> */}
                    </Form> }
                    {showGuest && <Form ref={this.assignGuestFormRef} object={this.state} validator={guestCheckoutValidator}>
                        <AuthHeader text={t.menu("checkout-as-guest")} showLogo={false} />
                        <div className="form-group relative">
                            <h5>{t.menu("guest-email")}</h5>
                            <Input type="text" className="form-control" propertyName="guestEmail"
                                value={this.state.guestEmail || ""}
                                onChange={e => this.setState({ guestEmail: e.target.value })} maxLength={100} />
                        </div>
                        <div>
                            <a className={classNames(['button', css(btnStyles.default), 'text-center'])} onClick={this.onGuestCheckout}>{t.menu("checkout-as-guest")}</a>
                        </div>
                    </Form>}
                </div>
            </div>
        );
    }
}